import { IgxNumberSummaryOperand, IgxSummaryOperand } from '@infragistics/igniteui-angular/grids/core';
import { IgxSummaryResult } from '@infragistics/igniteui-angular/core';
import {CurrencyPipe, PercentPipe} from "@angular/common";
import {ClsUtil} from "../../../util/cls-util";

class GridSummariesCustomNeo {
  /** Summary tipo filas (#) */
  static filasSummary = class extends IgxSummaryOperand {
    public override operate(data?: any[]): IgxSummaryResult[] {
      const currencyPipe = new CurrencyPipe('es-MX');
      return [{
        key: 'cuenta',
        label: '#',
        summaryResult: currencyPipe.transform(IgxNumberSummaryOperand.count(data), '', '', '1.0')
      }];
    }
  };

  /** Summary tipo custom filas (cuanto de cuanto) */
  static customFilasSummary = class extends IgxSummaryOperand {
    public override operate(data?: any[], allData: any[] = []): IgxSummaryResult[] {
      const result: IgxSummaryResult[] = [];
      const hayMas = data.length === 0 ? 0 : allData[0]?.CantidadFalta ?? 0;
      const cuantoDeCuanto = hayMas < 0
        ? `${ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(IgxNumberSummaryOperand.count(data), '1.0')} / ${ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(IgxNumberSummaryOperand.count(data), '1.0')}`
        : `${ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(IgxNumberSummaryOperand.count(data), '1.0')} / ${ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(hayMas, '1.0')}`;
      result.push({ key: 'cuenta', label: '#', summaryResult: cuantoDeCuanto });
      return result;
    }
  };

  /** Summary tipo moneda (Σ) */
  static monedaSummary = class extends IgxSummaryOperand {
    public override operate(data?: any[]): IgxSummaryResult[] {
      const currencyPipe = new CurrencyPipe('es-MX');
      return [{
        key: 'suma',
        label: 'Σ',
        summaryResult: currencyPipe.transform(IgxNumberSummaryOperand.sum(data), '$ ', 'symbol-narrow', '1.2-2')
      }];
    }
  };

  /** Summary tipo porcentaje */
  static porcentajeSummary = class extends IgxSummaryOperand {
    public override operate(data?: any[]): IgxSummaryResult[] {
      const percentPipe = new PercentPipe('es-MX');
      return [{
        key: 'suma',
        label: '',
        summaryResult: percentPipe.transform(IgxNumberSummaryOperand.sum(data), '1.2-2')
      }];
    }
  };

  /**
   * Summary programa obra.
   * Si se recibe fieldName (columna de cantidad o %), muestra en el summary la suma de la columna
   * currency asociada (campo_fieldName + '_currency'), de forma reactiva al cambiar los valores currency.
   * Si no hay fieldName, mantiene el comportamiento legacy (suma de row.importe).
   */
  static importeProgObraSummary = class extends IgxSummaryOperand {
    public override operate(data?: any[], allData: any[] = [], fieldName?: string): IgxSummaryResult[] {
      const currencyPipe = new CurrencyPipe('es-MX');
      let totalImporte = 0;

      if (fieldName != null && fieldName !== '' && Array.isArray(allData) && allData.length > 0) {
        const currencyField = fieldName.replace(/_number$/, '') + '_currency';
        for (const row of allData) {
          totalImporte += Number(row[currencyField] ?? 0);
        }
      } else {
        for (const row of allData) {
          totalImporte += Number(row?.importe ?? 0);
        }
      }

      return [
        {
          key: 'totalImporte',
          label: '$ ',
          summaryResult: currencyPipe.transform(totalImporte, 'MXN', 'symbol-narrow', '1.2-2')
        }
      ];
    }
  };
}

export default GridSummariesCustomNeo
